export function Skeleton({
	className = "",
	width,
	height,
}: {
	className?: string;
	width?: number | string;
	height?: number | string;
}) {
	return (
		// bg-paper is nearly indistinguishable from bg-ground and from the
		// bg-paper surfaces it sits on (both are subtle near-white/near-black
		// elevation tones) — bg-hairline gives the pulse a visible tone against
		// either surface without adding a new token.
		<span className={`block animate-pulse rounded-md bg-hairline ${className}`} style={{ width, height }} aria-hidden />
	);
}

export function SkeletonList({
	rows = 4,
	rowHeight = 44,
	gap = 4,
}: {
	rows?: number;
	rowHeight?: number;
	gap?: number;
}) {
	return (
		<div className="flex flex-col" style={{ gap }} role="status" aria-label="Loading">
			{Array.from({ length: rows }).map((_, i) => (
				<Skeleton key={i} height={rowHeight} className="w-full" />
			))}
		</div>
	);
}
